
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/your-offer-salary",
      function () {
        return require("private-next-pages/your-offer-salary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/your-offer-salary"])
      });
    }
  